<div class="invoices-banner">
    <div class="banner-title">{{ 'BILLING.INVOICES' | translate }}</div>
  
    <div class="search-bar">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <circle cx="6" cy="6" r="4.5" stroke="#9DA9AD" stroke-width="1.3"/>
        <line x1="9.5" y1="9.5" x2="13" y2="13" stroke="#9DA9AD" stroke-width="1.3" stroke-linecap="round"/>
      </svg>
      <input
        [(ngModel)]="searchQuery"
        (ngModelChange)="searchQueryChange.emit($event)"
        [placeholder]="'BILLING.SEARCH_PLACEHOLDER' | translate"
        class="search-input" />
    </div>
  
    <app-invoice-filter-bar
      [eventTypes]="eventTypes"
      [invoiceSiteNames]="invoiceSiteNames"
      (monthRangeChange)="monthRangeChange.emit($event)"
      (siteFilterChange)="siteFilterChange.emit($event)"
      (eventTypeFilterChange)="eventTypeFilterChange.emit($event)">
    </app-invoice-filter-bar>
  </div>
  